// Auto-ported from the age-of-mcp /gallery. Low-poly parts flattened to a
// self-contained model (no shared helpers, no animations).
import * as THREE from "three";
import { defineModel } from "../../lib";

export const topiary = defineModel({
  id: "topiary",
  batchId: "future",
  name: "Topiary",
  tags: ["scenery","topiary","low-poly","age-of-mcp","future"],
  summary: "Topiary — a shrub clipped into shape for ornamental gardens.",
  description: "Ported from the age-of-mcp gallery (future library).",
  author: "age-of-mcp",
  footprint: 0.16,
  variants: [
    { id: "variant-0", label: "Variant 1", parts: () => [
      { geometry: new THREE.CylinderGeometry(0.11, 0.08, 0.16, 8), color: "#9a6a3c", position: [0, 0.08, 0] },
      { geometry: new THREE.TorusGeometry(0.1, 0.018, 4, 8), color: "#6f4a26", position: [0, 0.15, 0], rotation: [1.570796, 0, 0] },
      { geometry: new THREE.CylinderGeometry(0.022, 0.022, 0.12, 5), color: "#7a512c", position: [0, 0.22, 0] },
      { geometry: new THREE.IcosahedronGeometry(0.11, 0), color: "#46773a", position: [0, 0.34, 0] },
      { geometry: new THREE.IcosahedronGeometry(0.085, 0), color: "#579046", position: [0, 0.5, 0] },
      { geometry: new THREE.IcosahedronGeometry(0.055, 0), color: "#46773a", position: [0, 0.62, 0] },
    ] },
    { id: "variant-1", label: "Variant 2", parts: () => [
      { geometry: new THREE.CylinderGeometry(0.11, 0.08, 0.16, 8), color: "#9a6a3c", position: [0, 0.08, 0] },
      { geometry: new THREE.TorusGeometry(0.1, 0.018, 4, 8), color: "#6f4a26", position: [0, 0.15, 0], rotation: [1.570796, 0, 0] },
      { geometry: new THREE.CylinderGeometry(0.022, 0.022, 0.12, 5), color: "#7a512c", position: [0, 0.22, 0] },
      { geometry: new THREE.ConeGeometry(0.13, 0.4, 8), color: "#46773a", position: [0, 0.46, 0] },
      { geometry: new THREE.TorusGeometry(0.1, 0.02, 4, 9), color: "#579046", position: [0, 0.38, 0], rotation: [1.570796, 0, 0] },
      { geometry: new THREE.TorusGeometry(0.065, 0.018, 4, 9), color: "#579046", position: [0, 0.52, 0], rotation: [1.570796, 0, 0] },
    ] },
    { id: "variant-2", label: "Variant 3", parts: () => [
      { geometry: new THREE.CylinderGeometry(0.11, 0.08, 0.16, 8), color: "#9a6a3c", position: [0, 0.08, 0] },
      { geometry: new THREE.TorusGeometry(0.1, 0.018, 4, 8), color: "#6f4a26", position: [0, 0.15, 0], rotation: [1.570796, 0, 0] },
      { geometry: new THREE.CylinderGeometry(0.022, 0.022, 0.12, 5), color: "#7a512c", position: [0, 0.22, 0] },
      { geometry: new THREE.BoxGeometry(0.22, 0.24, 0.22), color: "#46773a", position: [0, 0.42, 0] },
      { geometry: new THREE.BoxGeometry(0.24, 0.04, 0.24), color: "#579046", position: [0, 0.54, 0] },
    ] },
  ],
  animations: [],
});
